export enum Term {
    daily = 1,
    weekly = 2,
    monthly = 3,
    perMile = 4,
    perHour = 5,
    flat = 6
  }
